export const PROFILE_URL = "profile";
export const GET_MY_CATEGORY_LIST_URL = "/category/my";
export const SET_MY_CATEGORY_URL = "/category/set";
export const REMOVE_MY_CATEGORY_URL = "/category/remove";
